import { Alignment, Navbar, NavbarGroup } from '@blueprintjs/core';
import React, { Component } from 'react';
import { exceptionsFontStyle, houstonIconStyle, permissionContainer } from './styles';
const houstonIcon = require('../img/houston_icon.svg');
class PermissionDeniedView extends Component {

    render() {
        return (
            <div>
                <Navbar>
                    <NavbarGroup align={Alignment.LEFT} >
                        <span><img alt="houston-icon" style={houstonIconStyle} src={houstonIcon} /></span>
                    </NavbarGroup>
                </Navbar>
                <div style={permissionContainer}>
                    <div style={exceptionsFontStyle}>
                        You do not have permission to access this application. Please contact American Logistics help desk if you need access.
            </div>
                </div>
            </div>

        )
    }
}

export default PermissionDeniedView;
